import gql from 'graphql-tag'

export const gqlPedidosEntregasRecargas = gql`
  query pedidosEntregasRecargas($conta: String!) {
    buscarPedido(conta: $conta) {
      pedido
      data
    }
    buscarEntrega(conta: $conta) {
      arsMestre {
        id
        codRastreio
        tipoRegistro
        cnpjCpf
        razaoSocial
        numeroRegistro
        codigoRetorno
        tipoProduto
        codigoPedido
        qtdeIdentificadores
        nome
        statusPedido
        dataEntrega
        peso
        valor
        tipoKit
        identificadores
        motivo
        conta
        codigoCliente
        dataPrevistaEntrega
        lote
      }
    }
    temRecarga(conta: $conta) {
      status
    }
  }
`

export const transformRastreio = (src, orderNumber) => {
  const { buscarPedido: orders, buscarEntrega: detailsQuery, temRecarga: recargaQuery } = src.data
  const { status: temRecarga } = recargaQuery
  const { arsMestre: detailsList } = detailsQuery

  const status = temRecarga ? 'Pagamento Aprovado' : 'Aguardando pagamento'
  const order = orders.find(o => parseInt(o.pedido, 10) === parseInt(orderNumber, 10))

  const fullOrder = {
    id: order.pedido,
    ticket: order.pedido,
    payment: {
      id: order.pedido,
      status,
      date: order.data
        .split('-')
        .reverse()
        .join('/')
    },
    tracker: []
  }

  // recuperar envio mais recente
  const orderDetail = detailsList.filter(
    o => parseInt(o.codigoPedido, 10) === parseInt(orderNumber, 10)
  )

  const transportes =
    orderDetail &&
    orderDetail.find(
      d =>
        d.statusPedido === 'TRANSPORTE' ||
        d.statusPedido === 'ENTREGUE' ||
        d.statusPedido === 'DEVOLVIDO' ||
        d.statusPedido === 'EXTRAVIADO'
    )

  if (transportes) {
    const transporte = Array.isArray(transportes)
      ? transportes.find(d => d.statusPedido === 'TRANSPORTE')
      : transportes
    const dtEnvio = new Date(parseInt(transporte.dataEntrega, 10))
    fullOrder.tracker.push({
      id: transporte.id,
      tipo: 'envio',
      status: 'Em Transporte',
      date: dtEnvio
        .toISOString()
        .substr(0, 10)
        .split('-')
        .reverse()
        .join('/'),
      showNotArrived: new Date().getTime() > transporte.dataPrevistaEntrega
    })
  } else {
    fullOrder.tracker.push({
      id: '',
      tipo: 'envio',
      status: 'Em Transporte',
      date: '',
      showNotArrived: false
    })
  }

  const entregues =
    orderDetail &&
    orderDetail.find(
      d =>
        d.statusPedido === 'ENTREGUE' ||
        d.statusPedido === 'DEVOLVIDO' ||
        d.statusPedido === 'EXTRAVIADO'
    )

  if (!entregues) {
    fullOrder.tracker.push({
      id: '',
      tipo: 'entrega',
      status: 'Entregue',
      date: ''
    })
  } else {
    const dtEntrega = new Date(parseInt(entregues.dataEntrega, 10))
    fullOrder.tracker.push({
      id: entregues.id,
      tipo: 'entrega',
      status: entregues.statusPedido,
      date: dtEntrega
        .toISOString()
        .substr(0, 10)
        .split('-')
        .reverse()
        .join('/')
    })
  }
  return fullOrder
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/tracking.js